import React from "react";
function RefundPolicy({goBack}) {
  return (
    <div className="Refund-section">


        {/* <button onClick={goBack} className="back-btn">
        ← Go Back
      </button> */}

        <h1>Refund and Cancellation Policy</h1>
        <p>This Refund and Cancellation Policy (“Policy”) governs the terms and conditions applicable
 to cancellations of services and refund of fees paid to AayurCare (“Company”, “we”, “our”,
 “us”). By subscribing to, purchasing, or using our medical reimbursement plans, services, or
 memberships, you (“Customer”, “you”, “your”) acknowledge and agree to this Policy.</p>


 <h3> 1. General Provision</h3>
 <p> 1.1 All payments made to AayurCare are considered final, non-cancellable, and non
refundable, except as specifically provided herein
<br></br>
1.2 Customers are advised to carefully review plan details and terms of service prior to
 making any payment
 <br></br>
  1.3 The Company reserves the right to accept or reject any cancellation or refund request at its
 sole discretion.</p>


 <h3> 2. Cancellation of Membership or Plan</h3>
 <p>
     2.1 Before Activation
     <br></br>
      If a cancellation request is received prior to plan activation, the Customer may be eligible for
 a full refund of the membership fee, subject to verification
 <br></br>
  2.2 After Activation:
  <br></br>
   Once a plan has been activated and benefits made available, the membership is deemed
 utilized and cancellations will not be permitted.No refund will be issued for voluntary cancellation after activation
 </p>


 <h3>Refund Eligibility</h3>
 <p> 
    Refunds may be considered only in the following limited situations
    <br></br>
     Verified duplicate or erroneous payment caused by a technical or banking error.
     <br></br>
      Non-activation of the plan or non-provision of services directly attributable to Aayur Care.
      <br></br>
      Incorrect deduction or disbursement of claim amount solely due to clerical or system error.
 </p>


<h3> 4. Non-Refundable Situations</h3>
<p> No refunds shall be provided under the following circumstances
 <br></br>
  a) Where services, reimbursements, or benefits have already been availed in part or full
  <br></br>
   b) Where the cancellation request is made after activation of the plan.
   <br></br>
   c) Where dissatisfaction, non-usage, or expectation mismatch is cited as the reason.
   <br></br>
   d) Where the Customer fails to prov
   ide valid documentation to substantiate the refund request
</p>


<h3>Refund Process</h3>
<p>5.1 All refund or cancellation requests must be made in writing to info@aayurcare.com, and
 must include:
 <br></br>
  Customer’s full name
  <br></br>
  Membership/Customer ID
  <br></br>
 Payment transaction reference number
 <br></br>
 Reason for refund or cancellation
 <br></br>
5.2 Upon receipt of a valid request, Aayur Care shall review the case and communicate its
 decision within five (5) working days.
 <br></br>
 5.3 Approved refunds shall ordinarily be credited within ten (10) to fifteen (15) working days
 to the original payment method.
 <br></br>
 5.4 The decision of Aayur Care regarding refund or cancellation eligibility shall be final and
 binding.
 </p>


 <h3> 6. Policy Amendments</h3>
 <p> Aayur Care reserves the right to modify, amend, or update this Policy at any time without
 prior notice. Customers are encouraged to review this Policy periodically.</p>

 <h3>7. Governing Law and Jurisdiction</h3>
 <p> This Policy shall be governed by and construed in accordance with the laws of India. Any
 dispute arising in connection with this Policy shall fall under the exclusive jurisdiction of the
 courts at Bengaluru, Karnataka, India</p>

 <h3> 8. Contact Information</h3>
 <p> For any questions or concerns related to this Policy, please contact
    <br></br>
    Aayur Care– Customer Support
    <br></br>
     Email: info@aayurcare.com
     <br></br>
     Phone: +91 73381 46712
 </p>












    </div>

    
  );
}

export default RefundPolicy;
